import {
    ProtectionPlanTypes,
    REQUEST_PROTECTION_PLAN_BUSINESS,
    RECEIVE_PROTECTION_PLAN_BUSINESS,
    IProtectionPlanResponse,
    IProduct,
    IPackage,
    ISmbLicenseLimit,
} from "./types";
import { AppThunkAction } from "../..";
import * as services from "../../service";

export const actionCreators = {
    requestProtectionPlan:
        (forceFullyRefresh: boolean): AppThunkAction<ProtectionPlanTypes> =>
        (dispatch, getState) => {
            const appState = getState();

            const productSortingNullLast = (ascending: boolean) => {
                return function (a: IProduct, b: IProduct) {
                    // equal items sort equally
                    if (a.orderBy === b.orderBy) {
                        return 0;
                    }
                    // nulls sort after anything else
                    else if (a.orderBy) {
                        return -1;
                    } else if (b.orderBy) {
                        return 1;
                    }
                    // otherwise, if we're ascending, lowest sorts first
                    else if (ascending) {
                        return a.orderBy < b.orderBy ? -1 : 1;
                    }
                    // if descending, highest sorts first
                    else {
                        return a.orderBy < b.orderBy ? 1 : -1;
                    }
                };
            };

            const calculateYearlySaving = (PackagePrice: number, PackagePriceYearly: number) => {
                let yearlySaving = "";
                const overallCostYearly = PackagePrice * 12;
                if (overallCostYearly !== 0) {
                    const saving = ((overallCostYearly - PackagePriceYearly) / overallCostYearly) * 100;
                    yearlySaving = saving.toFixed(2);
                }
                return yearlySaving;
            };

            const displayPaymentInfo = (pkg: IPackage) => {
                if (Number(pkg.PartnerId) === 428) {
                    return false;
                }
                return true;
            };

            const showBillingText = (pkg: IPackage) => {
                // Logic implemented to resolve BUG - 15366
                // where partner ID for commerce bank = 428

                if (Number(pkg.PartnerId) === 428 && pkg.IsUserPaid === false) {
                    return true;
                } else if (pkg.IsUserPaid && pkg.Price !== 0) {
                    return true;
                } else {
                    return false;
                }
            };

            const prepareBillingText = (text: any) => {
                let billingText = "";
                if (text && text.length > 0) {
                    billingText = text[0].toUpperCase() + text.substring(1);
                }
                return billingText;
            };

            const preparePackageProducts = (productList: IProduct[], packageInfoData: any) => {
                let packageProducts: IProduct[] = [];

                productList.forEach((product: IProduct) => {
                    if (!product.IsHidden) {
                        let packageProduct: IProduct = { ...product };

                        // let foundInProduct = packageInfoData.Products?.find((it: any) => it.Id === product.id);
                        // let foundInChildProduct = packageInfoData.ChildProducts?.find((it: any) => it.Id === product.id);

                        let foundInProduct = packageInfoData.Products?.find(
                            (it: any) => it.DisplayName === product.displayName || it.ParentDisplayName === product.displayName
                        );
                        let foundInChildProduct = packageInfoData.ChildProducts?.find(
                            (it: any) => it.DisplayName === product.displayName || it.ParentDisplayName === product.displayName
                        );

                        if (foundInProduct || foundInChildProduct) {
                            packageProduct.productDifferenceId = product.id;

                            if (foundInProduct && foundInProduct.LebelText) {
                                packageProduct.labelText = foundInProduct.LebelText;
                                packageProduct.icon = foundInProduct.LebelText;
                            } else if (foundInChildProduct && foundInChildProduct.LebelText) {
                                packageProduct.labelText = foundInChildProduct.LebelText;
                                packageProduct.icon = foundInChildProduct.LebelText;
                            } else {
                                packageProduct.icon = "==tick==";
                            }
                        } else {
                            packageProduct.icon = "==cross==";
                        }

                        packageProducts.push(packageProduct);
                    }
                });
                return packageProducts;
            };

            const prepareProductDifference = (allProductList?: IProduct[], pkg?: IPackage) => {
                let productDifference: IProduct[] = [];
                if (pkg?.IsActive) {
                    if (pkg.Products && pkg.Products.length > 0) {
                        productDifference.push(...pkg.Products);
                    }
                } else {
                    allProductList?.forEach((product: IProduct, index: number) => {
                        if (pkg?.Products && pkg.Products.length >= index && product.icon !== pkg.Products[index].icon) {
                            productDifference?.push({ ...product });
                        }
                    });
                }
                return productDifference;
            };

            let protectionPlanData: IProtectionPlanResponse;
            if (
                appState != null &&
                appState.protectionPlanBusinessState != null &&
                ((appState.protectionPlanBusinessState.protectionPlanData?.packageList == null && appState.protectionPlanBusinessState.isLoading === false) ||
                    forceFullyRefresh === true)
            ) {
                services
                    .getProtectionPlan()
                    .then((data) => {
                        data = JSON.parse(data);
                        var packages: IPackage[] = [];
                        var productList: IProduct[] = [];
                        if (data && data.IsSuccess) {
                            // making IsPackageCancel to false for child user
                            if (data.IsChildUser) {
                                data.PackageInformation = data.PackageInformation.filter((it: any) => it.IsActive == true);
                                if (data.PackageInformation) {
                                    data.PackageInformation.forEach(function (obj: any) {
                                        obj.IsPackageCancel = false;
                                    });
                                }
                            }

                            // preparing all products
                            data.PackageInformation?.forEach((packageInfoData: any) => {
                                packageInfoData.Products?.forEach((product: any) => {
                                    let foundProduct = productList.find(
                                        (it: IProduct) =>
                                            (product.Parent != null && it.parent === product.Parent) || (product.Parent == null && it.id === product.Id)
                                    );
                                    if (!foundProduct) {
                                        let tempProduct: IProduct = {
                                            parent: product.Parent,
                                            id: product.Id,
                                            displayName: product.Parent ? product.ParentDisplayName : product.DisplayName,
                                            description: product.Description,
                                            rowId: 1,
                                            name: "",
                                            labelText: product.LebelText,
                                            orderBy: product.OrderBy,
                                            isAddOnService: product.IsAddOnService,
                                            isChildProduct: false,
                                            IsHidden: false,
                                        };
                                        productList.push(tempProduct);
                                    }
                                });
                                packageInfoData.ChildProducts?.forEach((product: any) => {
                                    let foundProduct = productList.find(
                                        (it: IProduct) =>
                                            (product.Parent != null && it.parent === product.Parent) || (product.Parent == null && it.id === product.Id)
                                    );
                                    if (!foundProduct) {
                                        let tempProduct: IProduct = {
                                            parent: product.Parent,
                                            id: product.Id,
                                            displayName: product.Parent ? product.ParentDisplayName : product.DisplayName,
                                            description: product.Description,
                                            rowId: 1,
                                            name: "",
                                            labelText: product.LebelText,
                                            orderBy: product.OrderBy,
                                            isAddOnService: product.IsAddOnService,
                                            isChildProduct: true,
                                            IsHidden: false,
                                        };
                                        productList.push(tempProduct);
                                    }
                                });
                            });
                            // sorting all products
                            productList = productList?.sort(productSortingNullLast(true));

                            // preparing licenseLimits object to array
                            let licenseLimits: ISmbLicenseLimit[] = [];
                            Object.keys(data.smbLicenseLimits).map((key: string) => {
                                let licenseLimit: ISmbLicenseLimit = {
                                    key: key,
                                    value: data.smbLicenseLimits[key],
                                };
                                licenseLimits.push(licenseLimit);
                            });

                            licenseLimits.forEach((license) => {
                                let packageList: IPackage[] = [];
                                let packagepricingInformation = data.PackagePricringInformation?.filter((it: any) => it.Featurevalue === license.key);
                                packagepricingInformation?.forEach((pricingInfo: any) => {
                                    let packageInfo = data.PackageInformation?.find((it: any) => it.CatalogPackageID === pricingInfo.CatalogPackageID);

                                    let tempPackage: IPackage = {
                                        BasePackagePrice: Number(packageInfo.BasePackagePrice),
                                        BillingText: prepareBillingText(packageInfo.BillingText),
                                        HasUserCancelled: packageInfo.HasUserCancelled,
                                        IsActive: packageInfo.IsActive,
                                        IsPacakgeUpgradable: packageInfo.IsPacakgeUpgradable,
                                        IsPackageCancel: packageInfo.IsPackageCancel,
                                        PackagId: packageInfo.PackagId,
                                        PackageCode: packageInfo.PackageCode,
                                        CatalogPackageID: packageInfo.CatalogPackageID,
                                        PackageName: packageInfo.PackageName,
                                        PackagePrice: Number(packageInfo.PackagePrice),
                                        PackagePriceYearly: Number(packageInfo.PackagePriceYearly),
                                        DisplayPrice: data.DisplayPrice,
                                        SubcriptionType: packageInfo.SubcriptionType,
                                        PartnerId: data.PartnerId,
                                        PartnerName: packageInfo.PartnerName,
                                        ActionButtonText: "",
                                        Products: preparePackageProducts(productList, packageInfo),
                                        ShowCrossOut: packageInfo.ShowCrossOut,
                                        DisplayPaymentInfo: data.DisplayPaymentInfo,
                                        IsPSS: packageInfo.IsPSS,
                                        IsUserPaid: packageInfo.IsUserPaid,
                                        FeatureID: pricingInfo.FeatureID,
                                        Featurevalue: pricingInfo.Featurevalue,
                                        Price: Number(pricingInfo.Price),
                                        // UI Logic only
                                        ShowSubscriptionTypeChangeText: data.PartnerSubcritionType?.toUpperCase() === "BOTH",
                                        YearlySavingPrice: calculateYearlySaving(Number(packageInfo.PackagePrice), Number(packageInfo.PackagePriceYearly)),
                                        BasePackagePriceYearly: Number(packageInfo.BasePackagePriceYearly),
                                        ShowBillingText: false,
                                    };
                                    packageList.push(tempPackage);
                                });

                                packageList.sort((a: IPackage, b: IPackage) => (a.Price > b.Price ? 1 : -1));
                                const currentPackage: IPackage | undefined = packageList.find((it: IPackage) => it.IsActive);

                                packageList.forEach(function (pkg: IPackage, index: number) {
                                    pkg.ProductDifference = prepareProductDifference(pkg.Products, currentPackage);
                                    pkg.ShowBillingText = showBillingText(pkg);
                                    pkg.DisplayPaymentInfo = displayPaymentInfo(pkg);

                                    if (!currentPackage) {
                                        pkg.ActionButtonText = "Purchase";
                                    } else {
                                        const currentPackagePrice = currentPackage.Price;
                                        if (pkg.Price > currentPackagePrice) {
                                            pkg.ActionButtonText = "Upgrade";
                                        } else if (pkg.Price < currentPackagePrice) {
                                            pkg.ActionButtonText = "Downgrade";
                                        } else {
                                            const currentPkgIndex: any = packageList.findIndex((it) => it.IsActive);
                                            if (currentPkgIndex < index) {
                                                pkg.ActionButtonText = "Upgrade";
                                            } else if (currentPkgIndex > index) {
                                                pkg.ActionButtonText = "Downgrade";
                                            } else {
                                                pkg.ActionButtonText = "Cancel";
                                            }
                                        }
                                    }
                                });
                                packages.push(...packageList);
                                license.packageList = packageList;
                            });

                            protectionPlanData = {
                                packageList: packages,
                                productList: productList,
                                smbLicenseLimits: licenseLimits,
                                LicenseLimit: data.LicenseLimit,
                                ActiveAndPendingLicenseLimit: data.ActiveAndPendingLicenseLimit,
                            };
                            dispatch({ type: RECEIVE_PROTECTION_PLAN_BUSINESS, protectionPlanData: protectionPlanData });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        dispatch({ type: RECEIVE_PROTECTION_PLAN_BUSINESS, protectionPlanData: protectionPlanData });
                    });

                dispatch({ type: REQUEST_PROTECTION_PLAN_BUSINESS });
            }
        },
};
